import styled from 'styled-components';

export const DwtcVirtualAssetsLicensedActivitiesWrapper = styled.section`
  background-color: #ce445b;
  padding-top: 99px;
  padding-bottom: 101px;
  @media (max-width: 992px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }
`;
export const DwtcVirtualAssetsLicensedActivitiesContainer = styled.div`
  max-width: 1252px;
  position: relative;
  margin: 0px auto;
  @media (max-width: 1260px) {
    max-width: 100%;
    padding: 0px 15px;
  }
`;
export const DwtcVirtualAssetsLicensedActivitiesHeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
export const DwtcVirtualAssetsLicensedActivitiesHeader = styled.div`
  max-width: 1120px;
  text-align: center;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;
export const DwtcVirtualAssetsLicensedActivitiesTitle = styled.h2`
  margin: 0px;
  font-size: 30px;
  line-height: 30px;
  color: #fff;
  @media (max-width: 1199px) {
    font-size: 26px;
    line-height: 30px;
  }
  @media (max-width: 767px) {
    font-size: 24px;
    line-height: 30px;
  }
`;
export const DwtcVirtualAssetsLicensedActivitiesText = styled.p`
  margin: 0px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
`;
export const DwtcVirtualAssetsLicensedActivitiesBody = styled.div`
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 992px) {
    padding-top: 30px;
  }
`;
export const DwtcVirtualAssetsLicensedActivitiesFirstRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 60px;
  @media (max-width: 1199px) {
    column-gap: 20px;
  }
  max-width: 1190px;
  .activities_lists {
    width: 245px;
    @media (max-width: 1280px) {
      width: 21%;
    }
    @media (max-width: 992px) {
      width: calc(50% - 10px);
    }
    @media (max-width: 575px) {
      width: 100%;
    }
  }
`;
export const DwtcVirtualAssetsLicensedActivitiesSecondRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 70px;
  @media (max-width: 1199px) {
    column-gap: 20px;
  }
`;
export const DwtcVirtualAssetsLicensedActivitiesLists = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 27px;
  align-items: center;
  width: 260px;
  padding-bottom: 50px;
  @media (max-width: 1280px) {
    width: 20%;
    column-gap: 20px;
  }
  @media (max-width: 992px) {
    width: calc(50% - 10px);
    padding-bottom: 30px;
  }
  @media (max-width: 767px) {
    padding-bottom: 30px;
  }
  @media (max-width: 575px) {
    width: 100%;
  }
`;
export const DwtcVirtualAssetsLicensedActivitiesListImage = styled.div`
  height: auto;
  min-width: 44px;
  width: 44px;
  object-fit: contain;
  @media (max-width: 575px) {
    height: auto;
    min-width: 35px;
    width: 35px;
  }
`;
export const DwtcVirtualAssetsLicensedActivitiesListTitle = styled.div`
  h2 {
    margin: 0px;
    color: #e5e5e5;
    font-size: 18px;
    line-height: 24px;
    @media (max-width: 1199px) {
      font-size: 17px;
      line-height: 24px;
    }
    @media (max-width: 992px) {
      font-size: 15px;
      line-height: 24px;
    }
  }
  p {
    color: #e5e5e5;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    margin: 0px;
  }
`;
export const DwtcVirtualAssetsLicensedActivitiesButton = styled.div`
  text-align: center;
  display: flex;
  width: 100%;
  justify-content: center;
  a {
    padding-left: 38px !important;
    padding-right: 38px !important;
  }
`;
